import { Box, Typography, Button } from "@mui/material";
import React from "react";

import { useBrand } from "src/hooks/useBrand";

type Props = {
  email: string;
  rejected: boolean;
  loading: boolean;
  onAccept: () => void;
  onCancel: () => void;
};

export const AskToAssociate = ({ email, rejected, loading, onAccept, onCancel }: Props) => {
  const { identity } = useBrand();

  return (
    <Box sx={{ m: 1, textAlign: "center" }}>
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="subtitle1"
          sx={{
            mb: 2,
            color: "primary.main",
            lineHeight: "24px",
          }}
        >
          <b>
            L'adresse email
            <Box component="span" sx={{ color: email ? "danger.main" : "primary.main" }}>
              {" "}
              {email}
            </Box>{" "}
            est déjà utilisée comme identifiant {identity.name}.
          </b>
        </Typography>

        <Typography variant="subtitle1" sx={{ lineHeight: "24px", color: "secondary.main" }}>
          <b>Souhaitez-vous associer cette adresse email au compte en cours ?</b>
        </Typography>
      </Box>
      <Box
        sx={{
          mb: 2,
          color: rejected ? "gray.dark" : undefined,
          backgroundColor: rejected ? "gray.deep" : undefined,
        }}
      >
        <Button
          fullWidth
          size="large"
          color={rejected ? "inherit" : "primary"}
          variant="contained"
          loading={loading}
          onClick={onAccept}
        >
          OUI, ASSOCIER À L'EMAIL EXISTANT
        </Button>
      </Box>
      <Box
        sx={{
          color: rejected ? "common.white" : "gray.dark",
          backgroundColor: rejected ? "gray.dark" : "gray.deep",
        }}
      >
        <Button fullWidth color="inherit" onClick={onCancel}>
          NON, JE SOUHAITE UTILISER UN AUTRE EMAIL
        </Button>
      </Box>
    </Box>
  );
};
